import type { RouteLocationRaw } from 'vue-router'

// Redirects mobile users (< 768px) away from desktop-only routes.
// 768 matches the default breakpoint used by useIsMobile.
export default function isDesktopOnly(): RouteLocationRaw | boolean {
  const isMobile = typeof window !== 'undefined' && window.innerWidth < 768
  if (isMobile) {
    return { name: 'studio-plus-insights' }
  }
  return true
}
